import React from 'react';

import {IconTrash} from '@tabler/icons-react';
import type {CourseDefinitionQuizQuestionAnswerResponse} from 'src/api/ProactApiClient';
import {Button} from 'src/design/atoms/Button';
import {Checkbox} from 'src/design/atoms/Checkbox';
import {Group} from 'src/design/atoms/Group';
import {Stack} from 'src/design/atoms/Stack';
import {Textbox} from 'src/design/atoms/Textbox';

export interface QuestionAnswerFormProps {
  data: CourseDefinitionQuizQuestionAnswerResponse;
  mode: 'edit' | 'view';
  index: number;
  autoFocus?: boolean;
  onChange: (
    obj: CourseDefinitionQuizQuestionAnswerResponse,
    index: number
  ) => void;
  onDelete: (
    onj: CourseDefinitionQuizQuestionAnswerResponse,
    index: number
  ) => void;
}
export const QuestionAnswerForm: React.FC<QuestionAnswerFormProps> = ({
  data,
  mode,
  index,
  autoFocus,
  onChange,
  onDelete,
}) => {
  const disabled = mode === 'view';

  function handleDelete(): void {
    onDelete(data, index);
  }

  function handleTextChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void {
    onChange(
      {
        ...data,
        text: e.target.value,
      },
      index
    );
  }

  function handleIsCorrectChange(
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ): void {
    onChange(
      {
        ...data,
        isCorrect: checked,
      },
      index
    );
  }

  return (
    <Stack gap={0}>
      <Textbox
        label="Answer Text"
        placeholder="Enter answer text"
        value={data.text}
        required={true}
        disabled={disabled}
        multiline
        minRows={1}
        onChangeCallback={handleTextChange}
        props={{autosize: true, autoFocus}}
      />
      <Group justify="space-between" align="center">
        <Checkbox
          checked={data.isCorrect ?? false}
          label="Correct"
          size="md"
          disabled={disabled}
          onChange={handleIsCorrectChange}
        />
        {mode === 'edit' && (
          <Button
            onClick={handleDelete}
            size="sm"
            variant="subtle"
            color="red"
            leftSection={<IconTrash size={16} />}>
            Delete Answer
          </Button>
        )}
      </Group>
    </Stack>
  );
};
